module.exports = __webpack_public_path__ + "assets/images/udskriv-rykkere-til-daarlige-betalere.jpg";